"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-filename-extension */
var React = require("react");
var formatUrl_1 = require("./util/formatUrl");
var AppLink = function (props) {
    var to = props.to, hashType = props.hashType, replace = props.replace, message = props.message, children = props.children, rest = __rest(props, ["to", "hashType", "replace", "message", "children"]);
    var linkTo = formatUrl_1.default(to, hashType);
    return (React.createElement("a", __assign({}, rest, { href: linkTo, onClick: function (e) {
            e.preventDefault();
            // eslint-disable-next-line no-alert
            if (message && window.confirm(message) === false) {
                return false;
            }
            var changeState = window.history[replace ? 'replaceState' : 'pushState'];
            changeState({}, null, linkTo);
        } }), children));
};
exports.default = AppLink;
